// Mapeamento canônico de códigos de erro do backend para mensagens pt-BR (SEF-125-UX).
// SESSION_EXPIRED é tratado silenciosamente — o clienteHttp já acionou o redirect.
const MENSAGENS = {
  SESSION_EXPIRED: null,
  TIMEOUT: 'A requisição demorou demais. Verifique sua conexão.',
  NETWORK_ERROR: 'Sem conexão com o servidor. Verifique sua internet.',
  INVALID_CREDENTIALS: 'E-mail ou senha incorretos.',
  RATE_LIMITED: 'Muitas tentativas. Aguarde um momento e tente novamente.',
  NOT_FOUND: 'O registro não foi encontrado.',
  FORBIDDEN: 'Você não tem permissão para esta ação.',
  VALIDATION_ERROR: 'Verifique os dados preenchidos e tente novamente.',
  CONFLICT: 'Este registro já existe ou está em uso.',
  DEFAULT: 'Não foi possível completar a operação.',
};

export function mensagemParaCodigo(code) {
  if (code && code in MENSAGENS) return MENSAGENS[code];
  return MENSAGENS.DEFAULT;
}
